import { colors } from '../../colors';
var input = {
  textColor: colors.equineIron
};
export default input;